var map = {
	"./IC.jpg": 8577,
	"./aarambh.png": 2365,
	"./blockchain_speaker1.jpg": 9688,
	"./blockchain_speaker2.jpg": 7143,
	"./codehunt.jpg": 9373,
	"./gsoc_webinar.png": 7074,
	"./peripherithon.jpg": 9914,
	"./placement.jpeg": 905,
	"./runner_ups.png": 5556,
	"./techbrawl1.jpeg": 4909,
	"./techbrawl2.jpeg": 2028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6586;